import api from 'core/api';

export const signIn = (params) => api.get('new/auth/sign_in', { params });
export const validatePin = (params) => api.post('new/auth/sign_in', params);

export const authLogOut = () => api.delete('/auth/sign_out');
export const validateToken = () => api.get('/auth/validate_token');
export const changeUser = (userId) => api.patch(`/users/${userId}/admin_login`);
